import React from 'react'
import { Form, AutoComplete } from 'antd'

export const AutoCompleteInput = ({
  editable,
  name,
  label,
  message,
  initialValue = null,
  width = '100%',
  required = false,
  options,
  onSearch,
  onSelect,
  placeholder,
  ...others
}) => {
  if (!editable) return initialValue
  return (
    <Form.Item name={name} label={label} noStyle rules={[{ required: required, message: { message } }]}>
      <AutoComplete
        options={options}
        onSelect={onSelect}
        onSearch={onSearch}
        placeholder={placeholder}
        defaultValue={initialValue}
        {...others}
      />
    </Form.Item>
  )
}
